import React from "react";
import "./EmptyView.scss";
import classnames from "classnames";
import { huyaIconAssetsCdn } from "@huyafed/huya-icon-assets";

/**
 * @see https://git.huya.info/huyafed/components/huyafed-npm/-/tree/master/packages/huya-icon-assets
 */
const STATUS_MAP = {
  error: huyaIconAssetsCdn.emptyErrorGif,
  guide: huyaIconAssetsCdn.emptyGuideGif,
  happy: huyaIconAssetsCdn.emptyHappyGif,
  noPermission: huyaIconAssetsCdn.emptyNoPermissionGif,
  offline: huyaIconAssetsCdn.emptyOfflineGif,
  default: huyaIconAssetsCdn.emptyDefaultGif,
  defaultPitaya: huyaIconAssetsCdn.emptyDefaultPitaya,
  fly: huyaIconAssetsCdn.loadingGif,
  loading: huyaIconAssetsCdn.loadingGif,
};

export type TEmptyStatus = keyof typeof STATUS_MAP;

export interface IEmptyViewProps {
  emptySrc?: any;
  emptyText?: string;
  onClick?: Function;
  btnText?: string;
  style?: React.CSSProperties;
  className?: string;
  status?: TEmptyStatus;
  children?: React.ReactNode;
}
const EmptyView: React.FC<IEmptyViewProps> = ({
  emptySrc,
  emptyText,
  onClick,
  btnText,
  style,
  className,
  status,
  children,
}) => {
  const emptyImage = STATUS_MAP[status!];
  return (
    <div className={classnames("empty-view-wrap", className)} style={style}>
      <img src={emptySrc || emptyImage || STATUS_MAP.default} className="empty-icon" />
      {children ? (
        <>{children}</>
      ) : (
        <div className="content">
          <p>{emptyText || "暂无数据"}</p>
          {btnText && (
            <div
              className="btn-wrap"
              onClick={() => {
                onClick?.();
              }}
            >
              {btnText || "确认"}
            </div>
          )}
        </div>
      )}
    </div>
  );
};

export default EmptyView;
